<!--
배송취소 단계로 변경
------------------------------------
-->
<template>
    <!-- 모달 -->
    <div class="uk-modal-full" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog">
            <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
            <div uk-grid class="uk-grid-small uk-padding" uk-height-viewport>

                
                <div class="uk-card uk-card-default uk-card-body uk-card-small uk-width-medium">
                    <!-- 대기화면 -->
                    <div v-show="jobState === 'ready'">
                        <p class="uk-text-center uk-text-large">
                            선택한 주문서를 다른 센터로 <br />이동합니다.
                            <br />
                            (주문서 오등록시 사용)
                        </p>

                        <!-- 센터선택 -->
                        <div>
                            <i class="material-icons">radio_button_checked</i>
                            <b>이동할 센터를 선택하세요</b>
                            <div class="uk-margin-left">
                                <app-input-radio
                                    v-model="inputToRegionId"
                                    :options="toRegionIdOptions"
                                >
                                    <template
                                        slot="optionText"
                                        slot-scope="{ option }"
                                    >
                                        <img :src="option.flag16" />
                                        <span class="">{{ option.text }}</span>

                                    </template>
                                </app-input-radio>
                            </div>
                        </div>

                        <!-- 사유입력 -->
                        <div>
                            <i class="material-icons">description</i>
                            <b>센터이동 사유</b>
                            <div class="uk-margin-left">
                                <p-radio
                                    v-for="(opt, index) in reasonTypeOptions"
                                    :key="index"
                                    class="p-default p-curve uk-display-block m-5"
                                    color="primary"
                                    name="reason-type"
                                    :value="opt.name"
                                    :checked = "reasonType === opt.name"
                                    v-model="reasonType"
                                    v-on:change="initReason"
                                >
                                    <i slot="extra" class="icon mdi mdi-check"></i>
                                    {{ opt.name }}
                                </p-radio>
                            </div>
                            <div class="uk-margin-left">
                                <app-input-textarea
                                    class="uk-margin"
                                    placeholder="사유를 입력하면 로그에 기록됩니다"
                                    :textarea-rows="5"
                                    v-model.trim="inputReason"
                                ></app-input-textarea>
                            </div>
                        </div>


                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                v-on:click="jobStart()"
                            >
                                <span uk-icon="icon: play"></span>
                                작업시작
                            </button>
                        </div>

                        
                    </div>


                    <!-- 실행중 -->
                    <div v-show="jobState === 'doing'">
                        <p class="uk-text-center uk-text-danger uk-text-large">
                            작업이 진행중입니다.<br />
                            작업이 종료될때까지 브라우저를 닫지마세요
                        </p>
                    </div>

                    
                    <!-- 완료 -->
                    <div v-show="jobState === 'done'">
                        <p class="uk-text-center uk-text-primary uk-text-large">
                            작업이 완료되었습니다.<br />
                            브라우저를 닫아도 좋습니다.
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                v-on:click="refreshPage()"
                            >
                                <span uk-icon="icon: refresh"></span>
                                현재 페이지 새로고침
                            </button>
                        </div>
                    </div>


                    <!-- 입력값 표시 -->
                    <div v-show="jobState !== 'ready'" class="">
                        <hr />

                        <div v-if="toRegion">
                            <span class="uk-text-bold">이동할 센터: </span>
                            <img :src="toRegion.flag32" />
                            <span class="uk-text-large">{{ toRegion.name }}</span>
                        </div>
                        <br />
                        <span class="uk-text-bold">센터이동 사유: </span>
                        <span class="uk-text-primary">{{ inputReason }}</span>

                    </div>

                    

                </div>

                
        
                <div class="uk-width-expand uk-margin-top app-table-normal">
                    <!-- 진행률 -->
                    <div class="uk-text-large uk-text-primary uk-margin-left">
                        {{ successCount }} / {{ targetCount }}
                        <span v-show="failCount > 0" class="uk-text-danger">(실패 : {{ failCount }})</span>
                    </div>
                    <progress id="js-progressbar" class="uk-progress uk-margin-remove" :value="successCount" :max="targetCount" ></progress>


                    <!-- 리스트 -->
                    <table class="uk-table uk-table-small uk-table-middle app-prod-table uk-margin-top">
                        <colgroup>
                            <col style="width: 25rem">

                            <col style="width: 10rem">

                            <col style="width: 8rem">
                            <col style="width: 15rem">
                            <col style="width: 10rem">


                            <col style="width: 5rem">
                            <col style="width: 10rem">
                            <col style="width: 60px">

                            <col>


                        </colgroup>

                        <thead>
                        <tr>

                            <th scope="col" class="uk-text-center">
                                진행상태
                            </th>


                            <th scope="col" class="uk-text-center">
                                회원사/수취인
                            </th>

                            <th scope="col" class="uk-text-center">
                                상품번호
                            </th>
                            <th scope="col" class="uk-text-center">
                                해외오더/트래킹
                            </th>
                            <th scope="col" class="uk-text-center">
                                배송단계
                            </th>


                            <th scope="col" class="uk-text-center">
                                수량
                            </th>
                            <th scope="col" class="uk-text-center">
                                옵션/구입단가
                            </th>
                            <th scope="col" class="uk-text-center">
                                이미지
                            </th>

                            <th scope="col" class="uk-text-left">
                                상품명
                            </th>


                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="target in jobTargets">
                            <td class="uk-text-center">
                                <div title="센터" class="uk-margin-small-bottom uk-flex uk-flex-center">
                                    <div>
                                        <img :src="get_region(target.item.region_id).flag16" />
                                        <div class="">{{ get_region(target.item.region_id).name }}</div>
                                    </div>
                                    <div class="uk-text-primary">
                                        <i class="material-icons md-36">navigate_next</i>
                                    </div>
                                    <div v-if="toRegion">
                                        <img :src="toRegion.flag16" />
                                        <div class="">{{ toRegion.name }}</div>
                                    </div>
                                </div>

                                <div v-show="target.state === 'ready'" class="uk-text-muted">
                                    대기
                                </div>
                                <div v-show="target.state === 'doing'" class="uk-text-primary">
                                    <span uk-icon="icon: play"></span>
                                    처리중..
                                </div>
                                <div v-show="target.state === 'success'" class="uk-text-success">
                                    <span uk-icon="icon: check"></span>
                                    성공
                                </div>
                                <div v-show="target.state === 'fail'" class="uk-text-danger">
                                    <span uk-icon="icon: close"></span>
                                    실패
                                </div>

                                <!-- 작업메세지 -->
                                <div v-show="target.job_msg" class="uk-text-meta">
                                    {{ target.job_msg }}
                                </div>
                            </td>


                            <td class="uk-text-center">

                                <div title="회원사" class="uk-margin-small-bottom">
                                    {{ target.item.user_nick }}
                                </div>
                                <div title="수취인">
                                    {{ target.item.h_name }}
                                </div>
                                <div title="배송코드">
                                    {{ target.item.house_code }}
                                </div>
                            </td>


                            <td class="uk-text-center">
                                {{ target.item.id }}

                                <!-- 상세링크 -->
                                <a
                                    class="uk-link-reset uk-button uk-button-small uk-button-white uk-margin-small-top"
                                    :href="'/prods/'+target.item.id"
                                    target="_blank"
                                >상세</a>
                            </td>
                            <td class="uk-text-left">
                                <div>
                                    <i class="material-icons md-18">receipt</i>
                                    {{ target.item.buy_order_code }}
                                </div>
                                <div>
                                    <i class="material-icons md-18">local_shipping</i>
                                    {{ target.item.tracking_no }}
                                </div>
                            </td>
                            <td class="uk-text-center">
                                {{ target.item.state_text }}
                            </td>



                            <td class="uk-text-center">
                                {{ target.item.amount }}
                            </td>
                            <td class="uk-text-center">
                                <div title="색상">{{ target.item.color }}</div>
                                <div title="사이즈" class="uk-margin-small-bottom">{{ target.item.size }}</div>
                                <div title="구입단가">{{ target.item.buy_unit_price_text }}</div>
                                <div title="마켓 판매단가">{{ target.item.hp_order_unit_price_krw_text }}</div>
                            </td>
                            <td class="uk-text-center">
                                <img :src="target.item.img_url" width="50" />
                            </td>


                            <td class="uk-text-left">
                                {{ target.item.name }}
                            </td>



                        </tr>

                        </tbody>
                    </table>



                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import workableByOne from '../workable-by-one';
    import regionAble from "../../../common/region-able.vue";

    export default {
        mixins: [
            workableByOne,
            regionAble,
        ],
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 오사카 창고권한인지여부 (항공, 해상모두 포함)
             */
            isOsakaWarehouse: {
                type: Boolean,
                default: false
            },
        },
        data: function () {
            
            return {
                // 입력값 - 이동할 지역ID
                inputToRegionId: null,

                // 입력값-사유
                inputReason: '',

                // (array) 이동할 센터 options
                toRegionIdOptions: [],

                // (object) 하우스별 결과, house_id 를 키값으로 결과가저장
                responseByHouseId: [],

                // (array) 사유타입 목록
                reasonTypeOptions: [
                    {name: '항공운송 불가', text: "[항공운송 불가]\n"},
                    {name: '부피무게 10kg 초과 화물', text: "[부피무게 10kg 초과 화물]\n"},
                    {name: '주문서 등록 오류', text: "[주문서 등록 오류]\n"},
                    {name: '직접입력', text: ''},
                ],

                // (string) 현재 선택된 사유타입
                reasonType: '항공운송 불가',


            };
        },
        computed: {
            /**
             * 대상 지역
             * @returns {Region}
             */
            toRegion() {
                if (! this.inputToRegionId) {
                    return null;
                }
                return this.get_region(this.inputToRegionId);
            },
        },
        mounted() {
            // 사유 초기화 한번 실행
            this.initReason();
        },
        methods: {
            /**
             * 사유 초기화 (사유타입 선택시 동작)
             */
            initReason() {
                const result = _.find(this.reasonTypeOptions, { name: this.reasonType });
                //console.log(result);
                if (! result) {
                    return;
                }

                this.inputReason = result.text;
            },


            // 작업초기화 완료 후 모달창 띄우기 바로직전에 호출됨. (사용 컴포넌트에서 재정의 필요)
            jobInitialized() {
                // 전체 서비스지역 옵션 작성
                let regions = this.get_active_regions();
                // 오사카창고인경우는 오사카지역만 남김
                //console.log(regions, this.isOsakaWarehouse);
                if (this.isOsakaWarehouse) {
                    const osakaRegionIds = [9, 10];
                    // 조건에 맞는 항목만 남기기
                    regions = _.filter(regions, region => _.includes(osakaRegionIds, region.id));
                    //console.log(regions);
                }


                this.toRegionIdOptions = [];
                _.each(regions, (region) => {
                    this.toRegionIdOptions.push({
                        text: region.name,
                        val: region.id,

                        flag16: region.flag16,
                    });
                });


            },

            // 현재페이지 갱신
            refreshPage() {
                $.app.refresh();
            },

            /**
             * 작업시작 준비단계
             * - 값 검증
             * - 컨펌 처리
             * @return boolean
             */
            prepareJobStart() {
                // 입력값 검증
                if(! this.inputToRegionId) {
                    alert('이동할 센터를 선택하세요.');
                    return;
                }
                if(! this.inputReason) {
                    alert('사유는 반드시 입력해야 합니다.');
                    return;
                }

                // 컨펌
                return confirm(this.targetCount+' 개 주문서가 센터이동 됩니다. 정말 실행합니까?')
            },

            /**
             * getWorkPromise(target)
             * mixin 을 상속받는 컴포넌트에서 정의 필요함.
             * 1개 작업을 실행하는 Promise를 반환함.
             *  - resolve(job_msg) {}
             *  - reject(job_msg) {}
             *
             * @param target 작업대상 (jobTargets 배열의 아이템)
             * @return Promise
             */
            getWorkPromise(target) {

                return new Promise((resolve, reject) => {
                    // 같은 하우스가 작업된적 있으면 해당 결과를 동일하게 적용
                    if (target.prev && target.prev.response) {
                        let prev = target.prev;
                        if (prev.item.house_id === target.item.house_id) {
                            // 결과저장
                            target.response = prev.response;

                            // 해결
                            resolve(prev.response.msg);

                            return;
                        }

                    }

                    // ajax 옵션
                    let opts = {
                        type: 'PATCH',
                        url: '/houses/' + target.item.house_id + '/change-center/' + this.inputToRegionId,
                        data: {
                            _token: this.csrfToken,
                            reason: this.inputReason
                        },
                        dataType: 'json',
                        success: (response, textStatus, jqXHR) => {
                            // 단계 업데이트
                            //target.item.state_text = response.state_text;

                            // 결과저장
                            target.response = response;

                            // rejolve 처리
                            resolve(response.msg);

                        },
                        alert_error_msg: (msg) => {
                            // reject 처리
                            reject(msg);
                            //console.log('reject : ' + target.item.id + ' / ' + msg);
                        },
                    };
                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });
            },


        }
    }
</script>

<style lang="scss" scoped>

</style>